import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../list/components/table/main';
import LimitedGarantsProfitForm from './components/forms/limited-garants-profit-form';
import Filters from '../../shared/filters/main';
import Switch from '../../shared/switch-routes/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content guarant-approve-requests">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Switch
							intl={props.intl}
							places={[
								{ name: 'limited-garants', title: `Limited garants` },
								{ name: 'analysis-lim-garants', title: `Limited garants analysis` }
							]}
						/>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<LimitedGarantsProfitForm {...props}/>
						<div className="margin-0-10">
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.fetchData}
							>
								{props.intl('Apply')}
							</button>
						</div>
					</div>

					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		sortColumn: selectors.getSort(state),
		table: selectors.getTable(state),
		expandedIds: selectors.getExpandedIds(state),
		pagination: selectors.getPagination(state),
		calendarOfCreationDate: selectors.getCalendarOfCreationDate(state),
		isProfitVisible: selectors.getIsProfitVisible(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		filters: selectors.getFilters(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants-analysis/list/main.js